<template>
  <div>
    <i 
      class="gift material-icons clickable"
      v-if="!show"
      @click="select">card_giftcard</i>
    <div 
      v-else 
      class="number" 
      :class="{
        'selected': selected, 
        'fade-in': show && !selected
        }">
        {{number}}<span style="font-size: 20px">pts</span></div>
  </div>
</template>

<script>
export default {
  props: ["show"],
  data() {
    return {
      selected: false,
      number: Number.parseInt(Math.random() * 100) || 1 // make sure they can't get 0
    };
  },
  methods: {
    select() {
      this.selected = true;
      this.$emit("selected", this.number);
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../styles/animations";

i {
  font-size: 70px;
  opacity: .8;
  &:hover {
    font-size: 85px;
    opacity: 1;
  }
}


.number {
  font-size: 50px;
  opacity: .5;
}
.selected {
  font-size: 70px;
  opacity: 1;
}

</style>
